export default {
  cartIsOpen: false,
  cart: null,
  orderId: null,
};
